var _defs, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSadFace = function SvgSadFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 148 148",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:8px;}.cls-2{fill:currentColor;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Asset 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_00z_no-results",
    "data-name": "00z_no-results"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 74,
    cy: 74,
    r: 70
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.65,101.67a53.69,53.69,0,0,0-55.3,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 49,
    cy: 56,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 99,
    cy: 56,
    r: 7
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSadFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sadFace.bf09521e.svg";
export { ForwardRef as ReactComponent };